var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApolloGraphql1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-64 -42 972.6 331.6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 901,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.6 72.4h-24.3l-35.1 91.1h22l5.7-15.5h33.2l-6-17h-21.9l14.2-39.2 25.3 71.7h22zM506.9 163.5V72.4h19.5v74h38.5v17.1zM619.4 163.5V72.4H639v74h38.5v17.1zM398.7 88.7c16.2 0 29.3 13.1 29.3 29.3s-13.1 29.3-29.3 29.3-29.3-13.1-29.3-29.3 13.2-29.3 29.3-29.3m0-17.8c-26 0-47.1 21.1-47.1 47.1s21.1 47.1 47.1 47.1 47.1-21.1 47.1-47.1-21.1-47.1-47.1-47.1zM767.3 88.7c16.2 0 29.3 13.1 29.3 29.3s-13.1 29.3-29.3 29.3S738 134.2 738 118s13.1-29.3 29.3-29.3m0-17.8c-26 0-47.1 21.1-47.1 47.1s21.1 47.1 47.1 47.1 47.1-21.1 47.1-47.1-21.1-47.1-47.1-47.1zM272 72.4h-42.5v91.1h19.4v-31.4H272c16.2 0 29.3-13.7 29.3-29.9 0-16.1-13.1-29.8-29.3-29.8zm0 41.9h-23.1V90.2H272c6.3 0 11.5 5.7 11.5 12s-5.2 12.1-11.5 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 191.1c-1.7 0-3.2.8-4.1 2.1 0 0-4.4 5-6.7 7.4-10 10-21.6 17.8-34.5 23.3-13.4 5.7-27.6 8.5-42.3 8.5s-28.9-2.9-42.3-8.5c-12.9-5.5-24.6-13.3-34.5-23.3-10-10-17.8-21.6-23.3-34.5-5.7-13.4-8.5-27.6-8.5-42.3s2.9-28.9 8.5-42.3C30.5 68.6 38.3 56.9 48.3 47c10-10 21.6-17.8 34.5-23.3 13.4-5.7 27.6-8.5 42.3-8.5s28.9 2.9 42.3 8.5c9.4 4 18.1 9.2 26 15.6-.4 1.2-.7 2.6-.7 4 0 6.8 5.5 12.3 12.3 12.3s12.3-5.5 12.3-12.3S211.8 31 205 31c-1.7 0-3.3.3-4.7 1-20.5-16.8-46.6-26.9-75.2-26.9C59.6 5.1 6.5 58.2 6.5 123.8s53.1 118.7 118.7 118.7c36.7 0 69.4-16.6 91.2-42.8.9-.9 1.5-2.2 1.5-3.5-.1-2.8-2.4-5.1-5.1-5.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M908.6 289.6H-64V-42h972.6z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApolloGraphql1);
export default __webpack_public_path__ + "static/media/apollo-graphql-1.e6363c14bc68dbef72b6b703b1110bbf.svg";
export { ForwardRef as ReactComponent };